import React from "react"

import SyntaxHighlighter from 'react-syntax-highlighter'
import { ascetic } from 'react-syntax-highlighter/dist/esm/styles/hljs'

import responseExampleStyles from "./ResponseExample.module.css"

export default function ResponseExample({ example, description }) {

    return (
        <div className={responseExampleStyles.container}>
            <div className={responseExampleStyles.header}>
                <div className={responseExampleStyles.title}>
                    <div>Response Example</div>            
                </div>
                { description && 
                    <p>{description}</p>
                }
            </div>
            <div>
                <SyntaxHighlighter language='JSON' style={ascetic}>
                    {example}
                </SyntaxHighlighter>      
            </div>
        </div>
    )
}